module.exports = __webpack_public_path__ + "img/pin-map.1de5d2fa.svg";